module.exports = __webpack_public_path__ + "img/requirementFromBuyer.57cb04e5.png";